import React, { useState } from "react";
import { isEmpty } from "lodash";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import "../../assets/scss/datatables.scss";

import WalletAccounts from "./walletAccounts";
import WalletActivities from "./walletActivities";
import WalletStats from "./walletStats";
import WalletOverView from "./walletOverView";
import { wallets } from "common/data/crypto";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { useSelector } from "react-redux";
import { RootState } from "slices";

//redux

const CryptoWallet = () => {
  //meta title
  document.title = "Wallet";

  // const { wallet } = useSelector(selectProperties);
  const wallet = {
    id: "#SK0234",
    userName: "Henry Wells",
    email: "henrywells@abc.com",
    availableBalance: "$ 0",
    lastMonthDifference: "+ $ 0",
    lastMonthDifferencePercent: "+ 0 %",
    send: "$ 0",
    receive: "$ 0",
    withdraw: "$ 0",
    series: [
      {
        type: "area",
        name: "BTC",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        group: "apexcharts-axis-0",
      },
      {
        type: "area",
        name: "USDC",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        group: "apexcharts-axis-0",
      },
      {
        type: "line",
        name: "USD",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        group: "apexcharts-axis-0",
      },
    ],
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
        dashArray: [0, 0, 3],
      },
      fill: {
        type: "solid",
        opacity: [0.15, 0.05, 1],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      colors: ["#f1b44c", "#556ee6", "#50a5f1"],
    },
    walletHistory: [
      {
        id: "#SK3215",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3216",
        date: "04 Mar, 2020",
        type: "Sell",
        currency: "Ethereum",
        amount: "0.00413 ETH",
        amountinUSD: "$ 2123.01",
      },
      {
        id: "#SK3217",
        date: "04 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3218",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3219",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3220",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3221",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3222",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3223",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3224",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3225",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
      {
        id: "#SK3226",
        date: "03 Mar, 2020",
        type: "Buy",
        currency: "Bitcoin",
        amount: "1.00952 BTC",
        amountinUSD: "$ 9067.62",
      },
    ],
  };

  console.log(wallet);
  const walletsData = useSelector(
    (state: RootState) => state.WalletReducer.wallet
  );

  const [isMenu, setIsMenu] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<any>("1");

  // useEffect(() => {
  //   dispatch(onGetWallet());
  // }, [dispatch]);

  const toggleTab = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleMenu = () => {
    setIsMenu(!isMenu);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Crypto" breadcrumbItem="Wallet" />
          {!isEmpty(wallet) && (
            <Row>
              <Col xl={4}>
                <WalletStats
                  wallet={wallet}
                  isMenu={isMenu}
                  toggleMenu={toggleMenu}
                />
              </Col>
              <Col xl={8}>
                <Row>
                  {(wallets || [])?.map((item: any) => {
                    return (
                      <Col sm="4" key={item.id}>
                        <Card className="mini-stats-wid">
                          <CardBody>
                            <div className="d-flex">
                              <div className="me-3 align-self-center">
                                <i
                                  className={`mdi mdi-${item.icon} h2 text-${item.text} mb-0`}
                                />
                              </div>
                              <div className="flex-grow-1">
                                <p className="text-muted mb-2">
                                  {item.wallet} Wallet
                                </p>
                                <h5 className="mb-0">
                                  {" "}
                                  {item.coine}
                                  <span className="font-size-14 text-muted">
                                    {" "}
                                    = $ {item.price}.00{" "}
                                  </span>
                                </h5>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                <WalletOverView wallet={wallet} />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={12}>
              {!isEmpty(wallet["walletHistory"]) && (
                <WalletAccounts
                  walletHistory={wallet["walletHistory"]}
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              {!isEmpty(wallet["walletHistory"]) && (
                <WalletActivities
                  walletHistory={wallet["walletHistory"]}
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CryptoWallet;
